/**
 * 安全地读对象的属性
 * @author sunbinbin
 */
module.exports = function sget() {
  var args = [].slice.call(arguments)
  var result = args[0]

  for (var i = 1; i < args.length; i++) {
    try {
      result = result[args[i]]
    } catch (e) {
      return
    }
  }

  return result
}
